import { useMutation, useQuery } from '@apollo/client';
import { Link } from 'gatsby';
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import FormText from '../../../components/FormText/FormText';
import { Terms } from '../../../components/FormText/styled';
import { FORM_TEXT_TYPES } from '../../../components/FormText/types';
import { CenteredLoadingSpinner } from '../../../components/Shared/LoadingSpinner/LoadingSpinner';
import { vars } from '../../../reactive';
import { increaseFormPage } from '../../../reactive/actions';
import { AnalyticsEvents, trackEvent } from '../../../utils/analytics';
import { GetAllCountries, SignupUser } from '../../../utils/queries';

export type Country = {
  id: number;
  name: string;
};

const FormAccountPostcode = () => {
  const { register, handleSubmit, reset, formState } = useForm();
  const account = vars.newAccount();
  const currentBranchCountry = vars.currentBranch()?.address?.country || 'United Kingdom';
  const [signUp, { loading, error, data }] = useMutation(SignupUser);
  const { data: { countryGet: countries = [] } = {}, loading: loadingCountries } = useQuery<{ countryGet: Country[] }>(GetAllCountries, {
    fetchPolicy: 'cache-first'
  });

  const countriesToId = countries.reduce((acc, country) => {
    acc[country.name] = country.id;
    return acc;
  }, {});

  const onSubmit = (data: Record<string, string>) => {
    vars.newAccount({ ...account, ...data });
    trackEvent(AnalyticsEvents.POSTCODE_INPUT);
    signUp({
      variables: {
        name: account.name,
        email: account.email,
        postcode: data.postcode,
        consent_time: new Date(),
        country_id: countriesToId[currentBranchCountry]
      }
    });
  };

  useEffect(() => {
    if (data) {
      increaseFormPage();
    }
  }, [data]);

  // Disable postcode for now
  useEffect(() => {
    if (countries?.length) {
      onSubmit({ postcode: '' });
    }
  }, [countries?.length]);

  if (true) {
    return <CenteredLoadingSpinner />;
  }

  return (
    <FormText type={FORM_TEXT_TYPES.POSTCODE} formOptions={{ register, handleSubmit, reset, formState }} onSubmit={onSubmit} loading={loading} error={error}>
      <Terms>
        <span>
          I accept{' '}
          <Link to="https://www.collar.pet/terms" target="_blank" rel="noopener noreferrer">
            terms & conditions
          </Link>
        </span>
      </Terms>
    </FormText>
  );
};
export default FormAccountPostcode;
